<template>
  <button
    type="button"
    class="wf-back-to-top-button button-full"
    aria-label="Back to top"
    :class="statusClass"
    @click="scrollToTop"
  >
    <span class="png-icon png-icon-icons-glyph--k-scroll-b2top"></span>
  </button>
</template>

<script>
export default {
  data() {
    return {
      statusClass: 'wf-back-to-top-button-inactive'
    }
  },
  created () {
    window.addEventListener('scroll', this.updateStatusClass);
    this.updateStatusClass();
  },
  destroyed () {
    window.removeEventListener('scroll', this.updateStatusClass);
  },
  methods: {
    updateStatusClass() {
      // Status class is 'active' when the window is scrolled down any amount
      this.statusClass = 'wf-back-to-top-button-' + (window.scrollY > 0 ? 'active' : 'inactive');
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }
};
</script>